import { render } from "./CategorySelect.vue?vue&type=template&id=59da43c5&ts=true"
import script from "./CategorySelect.vue?vue&type=script&lang=ts"
export * from "./CategorySelect.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__